import { render, staticRenderFns } from "./OrganizationViewRoles.vue?vue&type=template&id=0d9bf2cc&"
import script from "./OrganizationViewRoles.vue?vue&type=script&lang=js&"
export * from "./OrganizationViewRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports